import React from 'react';
import { ChevronRight, Lock, User } from 'lucide-react';

const ITEMS = [
  { label: 'ATS Integrations', locked: true },
  { label: 'Job board integration', badge: 'New' },
  { label: 'Branding & customizations', locked: true },
  { label: 'Manage account access' },
  { label: 'Change email' },
];

function SettingsLink({ item }) {
  return (
    <button className="w-full flex items-center justify-between px-4 py-3 rounded-xl border border-[#ECE6FA] bg-white hover:bg-[#FAF8FF]">
      <span className="text-[13.5px] font-semibold text-[#1A1533]">{item.label}</span>
      <span className="flex items-center gap-2">
        {item.badge && <span className="text-[10px] font-bold px-1.5 py-0.5 rounded bg-[#E9E3FB] text-[#5B4FE8]">{item.badge}</span>}
        {item.locked ? <Lock size={13} className="text-[#8A83A5]" /> : <ChevronRight size={14} className="text-[#8A83A5]" />}
      </span>
    </button>
  );
}

export default function GeneralTab() {
  return (
    <div>
      <h2 className="text-[18px] font-bold text-[#1A1533]">General</h2>
      <div className="mt-5 space-y-2">
        {ITEMS.map((item) => (
          <SettingsLink key={item.label} item={item} />
        ))}
      </div>
      <div className="mt-6">
        <p className="text-[13px] font-semibold text-[#1A1533]">Your photo</p>
        <div className="mt-3 flex items-center gap-4">
          <div className="w-14 h-14 rounded-full bg-[#EAE4FB] flex items-center justify-center">
            <User size={22} className="text-[#5B4FE8]" />
          </div>
          <button className="text-[13px] text-[#5B4FE8] font-semibold hover:underline">Change</button>
        </div>
      </div>
    </div>
  );
}
